/* Grace’ Routine 25.10.2026: Produktseite ohne Kaufangst. Daten kommen aus #gr-pdp-plus-data (snippets/gr-pdp-plus.liquid). */
(function () {
  var node = document.getElementById('gr-pdp-plus-data');
  if (!node || !window.GR_PDP_T) return;
  var D = JSON.parse(node.textContent);
    var L = D.lang === 'fr' ? 'fr' : (D.lang === 'de' ? 'de' : 'en');
    var T = window.GR_PDP_T[L];

    function q(s, r) { return (r || document).querySelector(s); }
    function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
    function leaf(txt) { return qa('main *').filter(function (e) { return e.children.length === 0 && e.textContent.trim() === txt; })[0]; }
    function el(tag, cls, html) { var e = document.createElement(tag); e.className = cls; e.innerHTML = html; return e; }
    function cents(c, n) { var v = Math.round(c / n * 10) / 10; var s = String(v); return L === 'en' ? s : s.replace('.', ','); }

    var ICON = {
      globe: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="20" cy="20" r="14"/><path d="M6 20h28M20 6c4.5 4 4.5 24 0 28M20 6c-4.5 4-4.5 24 0 28M9 12.5c6 2.5 16 2.5 22 0M9 27.5c6-2.5 16-2.5 22 0"/></svg>',
      box: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"><path d="M7 14l13-6 13 6v13l-13 6-13-6z"/><path d="M7 14l13 6 13-6M20 20v13"/></svg>',
      ret: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15h13a7 7 0 0 1 0 14H14"/><path d="M16 10l-5 5 5 5"/></svg>',
      samp: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"><rect x="13" y="8" width="7" height="24" rx="1"/><rect x="23" y="14" width="4" height="18" rx="0.6"/></svg>',
      shield: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6l12 4v9c0 8-5.5 13-12 15-6.5-2-12-7-12-15v-9z"/><path d="M15 20l4 4 7-8"/></svg>',
      leaf: '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"><path d="M32 8C18 8 9 16 9 28v4h4c12 0 19-9 19-24z"/><path d="M12 30c6-6 12-12 18-19"/></svg>'
    };
    function setItem(it, txt, svg) { if (!it) return; var t = q('.gr-trust__title', it); if (t) t.textContent = txt; var i = q('.gr-trust__icon', it); if (i && svg) i.innerHTML = svg; }

    function run() {
      if (document.documentElement.dataset.grPlus) return;
      document.documentElement.dataset.grPlus = '1';

      // fixed trust row and rotator
      var groups = qa('.gr-trust');
      if (groups[0]) { var a = qa('.gr-trust__item', groups[0]); setItem(a[0], T.ship, ICON.globe); setItem(a[1], T.ready, ICON.box); setItem(a[2], D.ds ? T.ret : T.samplesFree, D.ds ? ICON.ret : ICON.samp); }
      if (groups[1]) { var b = qa('.gr-trust__item', groups[1]); setItem(b[0], D.ds ? T.samplesEach : T.ret, D.ds ? ICON.samp : ICON.ret); setItem(b[1], T.packed, ICON.shield); setItem(b[2], T.vegan, ICON.leaf); }

      // scent line, stars with count, quote
      var title = q('h1.kt-product-title');
      var stars = q('.gr-stars');
      var count = stars ? (stars.getAttribute('aria-label') || '').split(',').pop().trim() : '';
      var anchor = title ? (title.closest('.gr-pdp-title-row') || title) : null;
      var sub = qa('.kt-card-text').filter(function (e) { return /extrait de parfum/i.test(e.textContent.trim()) && e.textContent.trim().length < 30; })[0];
      var lineHost = D.ds ? anchor : (sub || anchor);
      var lineTxt = D.ds ? T.dsLine : T.lines[D.handle];
      var line = null;
      if (lineHost && lineTxt) { line = el('div', 'gx-line', lineTxt); lineHost.after(line); }
      var after = line || lineHost;
      if (!stars && after && D.reviews > 0) { var s2 = el('div', 'gx-stars', '<b>★★★★★</b>'); after.after(s2); after = s2; }
      var starsBox = stars ? (stars.closest('.kt-product-star-rating') || stars).parentElement : after;
      // voices: shop reviews (verified) and personal feedback, one at a time, in the page language
      var qd = document.getElementById('gr-pdp-quotes'), list = [];
      try { list = (JSON.parse(qd.textContent) || {})[D.handle] || []; } catch (e) {}
      if (list.length && starsBox) {
        var qbox = el('div', 'gx-quote', list.map(function (x, n) {
          return '<div class="gx-quote__item' + (n ? '' : ' is-on') + '"' + (n ? ' aria-hidden="true"' : '') + '>' + T.qo + (x.t[L] || x.t.en) + T.qc + '<small>' + (x.by ? x.by + ' · ' : '') + (x.v ? T.verified : T.street) + '</small></div>';
        }).join(''));
        starsBox.after(qbox);
        var qi = 0, qs = qa('.gx-quote__item', qbox);
        if (qs.length > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) setInterval(function () {
          qs[qi].classList.remove('is-on'); qs[qi].setAttribute('aria-hidden', 'true');
          qi = (qi + 1) % qs.length; qs[qi].classList.add('is-on'); qs[qi].removeAttribute('aria-hidden');
        }, 6000);
      }

      // size cards: tightly cropped transparent flacon for 100 and 50 ml, shown whole inside the card
      var FLK = { 'velin-extrait-de-parfum': 'gr-variant-velin-flakon.png?v=1792962141', 'auree-extrait-de-parfum': 'gr-variant-auree-flakon.png?v=1792962141', 'saline-extrait-de-parfum': 'gr-variant-saline-flakon.png?v=1792962141' }[D.handle];
      if (FLK) qa('label.gr-size').forEach(function (l) { if (!/(100|50) ml/i.test(l.textContent)) return; var i = q('.gr-size__img img', l); if (!i) return; i.removeAttribute('srcset'); i.src = 'https://cdn.shopify.com/s/files/1/1047/4274/8497/files/' + FLK; l.classList.add('gx-flk'); if (/100 ml/i.test(l.textContent)) l.classList.add('gx-flk--100'); });
      qa('main *').filter(function (e) { return e.children.length === 0 && e.textContent.trim().toUpperCase() === T.best.toUpperCase(); }).forEach(function (e) { e.classList.add('gx-badge'); });

      // buy button label
      function relabel() {
        qa('form[action*="/cart/add"] button[type=submit] *, form[action*="/cart/add"] button[type=submit]').filter(function (e) { return e.children.length === 0 && /^[€$£]?\s?\d[\d.,]*\s?€?$/.test(e.textContent.trim()); }).forEach(function (e) { e.dataset.grPrice = '1'; e.textContent = T.add + ' · ' + e.textContent.trim(); });
      }
      relabel();

      // tax note above the button
      function hideTax() {
        qa('.kt-product-information span.kt-text-size--xsmall').filter(function (e) { return /^(tax(es)? included|inkl\.|inklusive|incl\.|taxes? incl|ttc|tva incluse|steuern inklusive)/i.test(e.textContent.trim()); }).forEach(function (e) { e.style.display = 'none'; });
      }
      hideTax();
      // accordion lines: only one line between two sections
      var firstToggle = q('.kt-product-information__inner > details.kt-toggle'); if (firstToggle) firstToggle.classList.add('gx-first');

      // credit card
      var tryCard = q('.gr-try__text') || (leaf('100 % als Guthaben') || {}).parentElement;
      if (tryCard) {
        // set page: the extra uppercase line repeats the headline
        var tl = D.ds && tryCard.parentElement ? q('.gr-try__link', tryCard.parentElement) : null; if (tl) tl.style.display = 'none';
      }

      // spray row follows the chosen size
      function sprayUpdate() {
        var row = qa('.kt-trust-attribute').filter(function (r) { return /SPRÜH|SPRAY|PULVÉRIS/i.test(r.textContent); })[0];
        if (!row) return;
        var val = q('.kt-trust-attribute__value', row); if (!val) return;
        var subv = q('.kt-trust-attribute__value-sub', row);
        if (!subv) { subv = el('span', 'kt-trust-attribute__value-sub', ''); val.after(subv); }
        if (D.ds) { val.textContent = T.dsSpray; subv.textContent = ''; return; }
        var checked = q('input.kt-product-variant__input:checked');
        var size = checked ? checked.value : '100 ml';
        var conf = T.sprays[size]; if (!conf) return;
        var c = size === '100 ml' ? cents(D.prices.c100, 3000) : (size === '50 ml' ? cents(D.prices.c50, 1500) : '');
        val.textContent = conf[0]; subv.textContent = conf[1].replace('{c}', c);
      }
      sprayUpdate();

      // gallery follows the chosen size (2 ml shows the sample image)
      function galleryFollow() {
        var data = q('[data-js-variant-data]'); if (!data) return;
        try { var v = JSON.parse(data.textContent); } catch (e) { return; }
        var src = v && v.featured_image && v.featured_image.src; if (!src) return;
        var file = src.split('/').pop().split('?')[0].replace(/\.(webp|jpg|jpeg|png)$/i, '');
        var target = qa('.kt-product-gallery-item').filter(function (s) { var i = q('img', s); return i && (i.currentSrc || i.src).indexOf(file) > -1; })[0];
        if (!target) return;
        var idx = qa('.kt-product-gallery-item').indexOf(target);
        var dots = qa('.kt-product-gallery .kt-css-slider-dot, .kt-product-gallery [data-index]');
        var dot = dots.filter(function (d) { return String(d.getAttribute('data-index')) === String(idx); })[0] || dots[idx];
        if (dot) { dot.click(); return; }
        var scroller = target.parentElement;
        while (scroller && scroller.scrollWidth <= scroller.clientWidth + 2) scroller = scroller.parentElement;
        if (scroller) scroller.scrollTo({ left: target.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
      }
      document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('kt-product-variant__input')) { setTimeout(function () { sprayUpdate(); galleryFollow(); relabel(); hideTax(); }, 350); setTimeout(function () { relabel(); hideTax(); }, 1200); } });

      // share: native share sheet on phones
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-gr-pdp-share]');
        if (!btn || !navigator.share || !window.matchMedia('(pointer: coarse)').matches) return;
        e.preventDefault(); e.stopImmediatePropagation();
        navigator.share({ title: D.title + ' · Grace’ Routine', text: D.title + ' von Grace’ Routine, Extrait de Parfum', url: location.href.split('?')[0] }).catch(function () {});
      }, true);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Merkliste: Symbol mit Zahl im Kopf, Liste auf /pages/merkliste */
(function () {
  var KEY = 'gr_saved_products';
  var CFG = window.GR_SAVED_CFG || {};
  var URL_SAVED = CFG.url || '/pages/merkliste';
  function read() { try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function icon() {
    var cart = document.querySelector('header a[href*="/cart"]'); if (!cart) return;
    var a = document.querySelector('.gx-heart');
    if (!a) {
      a = document.createElement('a'); a.className = 'gx-heart'; a.href = URL_SAVED;
      a.setAttribute('aria-label', CFG.label || 'Merkliste');
      a.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3.5h12a1 1 0 0 1 1 1V21l-7-4.2L5 21V4.5a1 1 0 0 1 1-1z"/></svg><i></i>';
      cart.parentElement.insertBefore(a, cart);
    }
    var n = read().length; a.querySelector('i').textContent = n ? String(n) : '';
  }
  function list() {
    var host = document.getElementById('gr-saved-list'); if (!host) return;
    var items = read();
    if (!items.length) { host.innerHTML = '<p class="gx-empty">' + (CFG.empty || '') + '</p>'; return; }
    Promise.all(items.map(function (h) { return fetch((CFG.root || '/').replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        host.innerHTML = '<div class="gx-saved">' + ps.filter(Boolean).map(function (p) {
          var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
          return '<a href="' + p.url + '"><img src="' + (p.featured_image || '') + '" alt="" loading="lazy"><h3>' + p.title + '</h3><p>' + (p.price_varies ? 'ab ' : '') + price + '</p></a>';
        }).join('') + '</div>';
      });
  }
  function go() { icon(); list(); setInterval(icon, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* Same cart button label outside product pages (e.g. Discovery Set on the homepage): "In den Warenkorb · €30" */
(function () {
  if (document.getElementById('gr-pdp-plus-data') || !window.GR_PDP_T) return;
  var l = (document.documentElement.lang || 'en').slice(0, 2);
  var T = window.GR_PDP_T[l === 'de' || l === 'fr' ? l : 'en'];
  function relabel() {
    Array.prototype.forEach.call(document.querySelectorAll('.gr-luxe-atc .gr-luxe-atc__price'), function (e) {
      var t = e.textContent.trim();
      if (/^[€$£]?\s?\d[\d.,]*\s?€?$/.test(t)) e.textContent = T.add + ' · ' + t;
    });
  }
  relabel();
  setInterval(relabel, 1000);
})();
